import { Component, OnInit, Input } from '@angular/core';
import {FormGroup, FormArray, FormBuilder,Validators} from '@angular/forms';
import{LoopBackAuth, listadosService} from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'datos-salida',
  template: `
  
  <form name="form-inscripciones" [formGroup]="responsables">
    <div class="row">
      <label class="col-sm-12 col-form-label">
      <strong>Indique que personas pueden retirar a la alumna en caso de enfermedad, permiso o emergencia.</strong><br/>
      Si la estudiante toma transporte externo coloque los datos del conductor para contactar.
      </label>
      <div class="col-sm-12">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th class="text-center bg-primary">Nombre y Apellido</th>
                <th class="text-center bg-primary">Parentesco</th>
                <th class="text-center bg-primary">Cedula</th>
                <th class="text-center bg-primary">Teléfono</th>
                <th>
                  <i
                  class="icofont icofont-plus-circle f-20 text-primary card-puntero"
                 
                  (click)="addFila()"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of responsables.controls | search:1  ; let i = index;" [formGroupName]="i">
                <td>
                  <div class="input-group input-group-sm mb-0">
                    <input
                    type="text"
                    class="form-control"
                    [style.border-radius]="'0px'"
                    name="nombre"
                    formControlName="nombre"
                    >
                  </div>
                </td>
                <td>
                  <div class="input-group input-group-sm mb-0">
                    <input
                    type="text"
                    class="form-control"
                    [style.border-radius]="'0px'"
                    name="parentesco"
                    formControlName="parentesco"
                    >
                  </div>
                </td>
                <td>
                <div class="input-group input-group-sm mb-0">
                  <input
                  type="text"
                  class="form-control"
                  [style.border-radius]="'0px'"
                  name="cedula"
                  formControlName="cedula"
                  >
                </div>
                </td>
                <td>
                  <div class="input-group input-group-sm mb-0">
                    <input
                    type="text"
                    class="form-control"
                    [style.border-radius]="'0px'"
                    name="telefono"
                    formControlName="telefono"
                    >
                  </div>
                </td>
                <td>
                  <i class="fas fa-trash-alt f-18 text-danger card-puntero" (click)="deleteFila(item, i)" [hidden]="preview"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
  <form name="form-inscripciones" [formGroup]="salida">
    <div class="row">
      <label class="col-sm-5 col-form-label">
          ¿ Toma el Transporte Escolar de la Institución?:
      </label>
      <div class="col-sm-6 form-radio">
        <div class="radio radio-inline pt-1" *ngFor="let item of tipos">
            <label>
                <input type="radio" name="transporte" [value]="item.id" formControlName="transporte" (change)="activarComboYAsignarPorDefecto()" >
                <i class="helper"></i>{{item.descripcion | uppercase}}
            </label>
        </div>
      </div>
      <label class="col-sm-12 col-form-label">
          ¿Cuál es la modalidad de transporte qué toma?
      </label>
      <div class="col-sm-12 form-radio">
        <div class="radio radio-inline pt-1" *ngFor="let item of modalidades">
            <label>
                <input type="radio" name="modalidad" [value]="item.id" formControlName="modalidad">
                <i class="helper"></i>{{item.descripcion | uppercase}}
            </label>
        </div>
      </div>
    </div>
  </form>
  `,
  providers:[LoopBackAuth, listadosService, MessageService]
})
export class DatosSalidaComponent implements OnInit {
  @Input() salida: FormGroup
  @Input() spinner: any

  public tipos : any
  public modalidades: any
  public responsables: FormArray
  public filtroCombo : boolean = false
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private listadosService:listadosService
  ) { }

  ngOnInit() {
    this.tipos = [
      {id:1,descripcion:"Si"},
      {id:2,descripcion:"No"}
    ]

    /** Busco el listado de tipos telefonicos */
    this.spinner.isSpinnerVisible = true
    this.listadosService.grupos('G_MODALIDAD_TRASNPOR').subscribe(
      result =>{
        this.modalidades = result.G_MODALIDAD_TRASNPOR.orden
        this.spinner.isSpinnerVisible = false
      }
    )
    /*this.modalidades = [
      {id:1, descripcion:"Propios medios (Transporte Publico)", intitucion:false},
      {id:2, descripcion:"Particular (Trasporte Propio)", intitucion:false},
      {id:3, descripcion:"Recorrido Externo (Buseta)", intitucion:false},
    ]*/
    this.responsables = this.salida.get('responsables') as FormArray
    this.crearFilasAutomaticas()
  }

  public crearFilasAutomaticas(){
    let numeroFilas = 3 - this.responsables.length
    if(numeroFilas > 0){
      for(let i = 0; i < numeroFilas; i++){
        this.addFila() 
       }
    } 
  }

  public activarComboYAsignarPorDefecto(){
    this.filtroCombo = (this.salida.get('transporte').value == 2) ? false: true
    if(this.salida.get('transporte').value == 1){
      this.salida.get('modalidad').disable()
      this.salida.get('modalidad').setValue(null)
    }
    if(this.salida.get('transporte').value == 2){
      this.salida.get('modalidad').enable()
      this.salida.get('modalidad').setValue(null)
    }
  }
  public addFila(){
    this.responsables.push(this.fb.group({
      id:[null],
      nombre:[null, Validators.required],
      parentesco:[null, Validators.required],
      cedula:[null, Validators.required],
      telefono:[null, Validators.required],
      estado:[1],
      existe:[0]
    }))
  }

  public deleteFila(item:any, index:number):void{
    if(item.get('existe').value == 1){
      item.patchValue({
        estado:-99
      })
    }else{
      this.responsables.removeAt(index)
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/fichaEstudiante/datos-salida.component.ts